import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedProducts: [],
  summary: []
};

const savedItemsSlice = createSlice({
  name: "savedItems",
  initialState,
  reducers: {
    saveProduct: (state, action) => {
      state.savedProducts.push(action.payload);
    },
    updateProduct: (state, action) => {
      const productIdIndex = state.savedProducts.findIndex(
        item => item.productId === action.payload.productId
      );

      if (productIdIndex >= 0) {
        state.savedProducts[productIdIndex] = action.payload;
      }
    },
    removeSavedProduct: (state, action) => {
      const productIdIndex = state.savedProducts.findIndex(
        item => item.productId === action.payload
      );

      if (productIdIndex !== -1) {
        state.savedProducts.splice(productIdIndex, 1);
      }
    },
    receiveSavedItemsSummary: (state, action) => {
      state.savedProducts.push(...action.payload);
    },
    removeFromSummary: (state, action) => {
      const summaryIndex = state.summary.findIndex(
        item => item.productId === action.payload
      );

      if (summaryIndex !== -1) {
        state.summary.splice(summaryIndex, 1);
      }
    }
  }
});

export const {
  saveProduct,
  updateProduct,
  removeSavedProduct,
  receiveSavedItemsSummary,
  removeFromSummary
} = savedItemsSlice.actions;

export const ADD_SAVED_PRODUCT = saveProduct.type;
export const UPDATE_SAVED_PRODUCT = updateProduct.type;
export const REMOVE_SAVED_PRODUCT = removeSavedProduct.type;
export const RECEIVE_SAVED_ITEMS_SUMMARY = receiveSavedItemsSummary.type;
export const REMOVE_FROM_SUMMARY = removeFromSummary.type;

export { isProductSaved, getIdForSavedProduct } from "./selectors";

export const reducer = savedItemsSlice.reducer;
export default savedItemsSlice.reducer;
